export default {
  placeholders: {
    delivery_zip_code: 'Código postal',
    delivery_city: 'Cidade',
    delivery_street_number: 'Número de porta',
    delivery_street_name: 'Nome da rua',
    type_your_address: 'Escreva o seu endereço',
  },
  errors: {
    address_suggestions_unavailable:
      'Não foi possível carregar as sugestões de morada. Pode continuar a introduzir a sua morada abaixo.',
  },
  buttons: {
    retry: 'Tentar novamente',
  },
};
